import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { buildDropzoneClassName } from '../../../helpers/fileValidationUtils';

const FileDropzone = ({
  onDrop,
  onDropRejected,
  accept,
  multiple = false,
  maxFiles = 1,
  disabled = false,
  noClick,
  noDrag,
  baseClassName,
  additionalClasses = {},
  ariaLabel = 'Drop files here',
  children,
  ...dropzoneProps
}) => {
  const { getRootProps, getInputProps, isDragActive, isDragReject } =
    useDropzone({
      onDrop,
      onDropRejected,
      accept,
      multiple,
      maxFiles,
      disabled,
      noClick: noClick !== undefined ? noClick : disabled,
      noDrag: noDrag !== undefined ? noDrag : disabled,
      ...dropzoneProps,
    });

  const className = buildDropzoneClassName(
    baseClassName,
    isDragActive,
    isDragReject,
    additionalClasses
  );

  const rootProps = {
    ...getRootProps(),
    role: 'button',
    'aria-label': ariaLabel,
  };

  return (
    <div {...rootProps} className={className}>
      <input {...getInputProps()} disabled={disabled} />
      {children({ isDragActive, isDragReject })}
    </div>
  );
};

FileDropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  onDropRejected: PropTypes.func,
  accept: PropTypes.object.isRequired,
  multiple: PropTypes.bool,
  maxFiles: PropTypes.number,
  disabled: PropTypes.bool,
  noClick: PropTypes.bool,
  noDrag: PropTypes.bool,
  baseClassName: PropTypes.string.isRequired,
  additionalClasses: PropTypes.object,
  ariaLabel: PropTypes.string,
  children: PropTypes.func.isRequired,
};

export default FileDropzone;
